const doc = [({"de":({"variousCandidates":"Verschiedene"}), "fr":({"variousCandidates":"Divers"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;